export const imageSizeValidator: (prop: string) => boolean = (prop: string) =>
  ['tiny', 'small', 'medium', 'large'].includes(prop);
